import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface AppBarProps {
  /** Brand lock-up / hamburger — pinned left. */
  start?: ReactNode;
  /** Primary navigation — fills the middle, hidden below `compactAt`. */
  center?: ReactNode;
  /** Account controls — pinned right. */
  end?: ReactNode;
  /** Full-width strip under the bar (needs-attention banner, provisioning…). */
  banner?: ReactNode;
  className?: string;
}

/** The sticky application top bar (brief §7.3): brand · navigation · account,
 *  with an optional full-bleed banner strip underneath. Layout only — what goes
 *  in each slot is the app's business. */
export function AppBar({ start, center, end, banner, className }: AppBarProps) {
  return (
    <header className={cx('tc-appbar', className)}>
      <div className="tc-appbar__row">
        {start && <div className="tc-appbar__start">{start}</div>}
        {center && <div className="tc-appbar__center">{center}</div>}
        {end && <div className="tc-appbar__end">{end}</div>}
      </div>
      {banner && <div className="tc-appbar__banner">{banner}</div>}
    </header>
  );
}

/** Class name for a top-bar / drawer navigation pill.
 *  Usage with react-router: `className={({ isActive }) => navPillClass(isActive)}`. */
export function navPillClass(active?: boolean, variant: 'bar' | 'drawer' = 'bar'): string {
  return cx('tc-navpill', variant === 'drawer' && 'tc-navpill--drawer', active && 'tc-navpill--active');
}
